<template>
	<div class="cinder" :style="styles"></div>
</template>

<script>
	import {elementInViewport} from '../../util';

	const blowAnimations = ['blow-left-1', 'blow-left-2'];
	const swayAnimations = ['sway-0', 'sway-1', 'sway-2', 'sway-3', 'sway-4', 'sway-5', 'sway-6', 'sway-7', 'sway-8'];
	const sizeBounds = [5,7];

	class Animation {
		constructor(name, duration, timingFunction = 'linear', iteration = 1, delay = 0) {
			this.name = name;
			this.duration = duration;
			this.timingFunction = timingFunction;
			this.delay = delay;
			this.iteration = iteration;
		}
	}

	export default {
		name: 'CinderParticle',
		props: {
			fallSpeed: {
				type: Number,
				default: 0.25
			}
		},
		data: () => ({
			fallTime: 0,
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			borderRadius: [0, 0],
			animations: [],
		}),
		created() {
			this.fallTime = ((document.documentElement.clientHeight * 0.007) + Math.round(Math.random() * 5)) * this.fallSpeed;

			this.animations.push(new Animation(
				'rise',
				this.fallTime
			));

			this.animations.push(new Animation(
				blowAnimations.randomElement(),
				Math.max(this.fallTime, 10) - Math.random() * 5,
				'ease',
				'infinite'
			));

			this.animations.push(new Animation(
				swayAnimations.randomElement(),
				2 + Math.random() * 2,
				'linear',
				'infinite'
			));

			this.height = sizeBounds[0] + Math.random() * (sizeBounds[1] - sizeBounds[0]);
			this.width = this.height - (Math.random() * sizeBounds[0]);

			this.borderRadius[0] = this.height;//sizeBounds[1] + Math.random() * (sizeBounds[1] + Math.random() * 10);
			this.borderRadius[1] = this.height;// + Math.random() * (this.width);

			this.x = Math.random() * 100;
			this.y = Math.random() * -10;
		},
		mounted() {
			this.$el.addEventListener(`animationend`, this.verifyIfInViewport);
			this.$el.addEventListener(`animationiteration`, this.verifyIfInViewport);
		},
		beforeDestroy() {
			this.$el.removeEventListener(`animationend`, this.verifyIfInViewport);
			this.$el.removeEventListener(`animationiteration`, this.verifyIfInViewport);
		},
		computed: {
			animation() {
				return this.animations
					.map(a => ` ${a.name} ${a.duration}s ${a.timingFunction} ${a.delay}s ${a.iteration}`)
					.join(', ');
			},
			styles() {
				return {
					animation: this.animation,
					width: this.width + 'px',
					height: this.height + 'px',
					borderRadius: `${this.borderRadius[0]}px ${this.borderRadius[1]}px`,
					left: this.x + `%`,
					top: this.y + `%`,
				}
			}
		},
		methods: {
			verifyIfInViewport() {
				if (!elementInViewport(this.$el)) {
					this.$emit('destroy');
				}
			}
		}
	}
</script>

<style lang="scss" src="./riseAnimation.scss"></style>
<style lang="scss" scoped src="./CinderParticle.scss"></style>
